<template>
    <div class="scrrolMidTable position-relative">
        <alert-notification v-if="notification_msg != ''"/>
        <section class="p-0 mt-3 border-0">
                {{tabActiveFunction}}
              <!--   <div class="forMobile-toggle d-none" :class="mobtoggleButton?'active':' '">
                    <a @click.prevent="mobtoggleButton = !mobtoggleButton" href="#" class="d-flex align-items-center justify-content-between">{{menu[loadServiceRequest]}} <feather size="16px" type="chevron-down" class="mobDrop"></feather> </a>
                </div> -->
                <!-- <div :class="mobtoggleButton?'active':' '" class="opendropdownMenu-mob depoist_fund map-nav d-flex align-items-center justify-content-between whiteBar"> -->
                    <div class="depoist_fund map-nav d-flex align-items-center justify-content-between whiteBar">
                    <!-- <ul class="d-flex align-items-center nav-tabs noBG w-100 mb-0 customSuprtTab-mob">
                        <li >
                            <a class="nav-link" :class="(loadServiceRequest == 'requestServiceElement')? 'active' : ''" data-toggle="tab" href="" v-on:click="setView = '' ; enableRequestElement('requestServiceElement')" >
                                <div class="mobDesg d-none">
                                    <feather type="settings"></feather>
                                </div>
                                <span>Support Request</span>
                            </a>
                        </li>
                        <li >
                            <a class="nav-link" :class="(loadServiceRequest == 'openRequest')? 'active' : ''" data-toggle="tab" href="" v-on:click="setView = '' ;  enableRequestElement('openRequest')" >
                                <div class="mobDesg d-none">
                                    <feather type="folder"></feather>
                                </div>
                                <span>Open Requests</span>
                            </a>
                        </li>
                        <li >
                            <a class="nav-link" :class="(loadServiceRequest == 'closeRequest')? 'active' : ''" data-toggle="tab" href="" v-on:click="setView = '' ;  enableRequestElement('closeRequest')" >
                                <div class="mobDesg d-none">
                                    <feather type="unlock"></feather>
                                </div>
                                <span>Closed Requests</span>
                            </a>
                        </li>
                    </ul> -->
                </div> 
        </section>
        <div class="mid_scroll_content scrollbar spPgae mt-0">
    		<loader v-if="pageLoader"></loader>
            
             
            <section class="tab-content border-0 max-1440 incgMob"> 
                <div  class="tab-pane  supportpagetab radius mb-3" :class="loadServiceRequest == 'requestServiceElement' ? ' in active' : ''">
                    <app-request-services v-if="loadServiceRequest == 'requestServiceElement'"></app-request-services>
                </div>
                
                <div  class="tab-pane" :class="loadServiceRequest == 'openRequest' ? ' in active' : ''">
                    <app-ticket-support v-if="loadServiceRequest == 'openRequest'" ></app-ticket-support>
                </div>
                
                <div  class="tab-pane" :class="loadServiceRequest == 'closeRequest' ? ' in active' : ''">
                    <app-ticket-support v-if="loadServiceRequest == 'closeRequest'"></app-ticket-support>
                </div>
            </section>
             
        </div>
    </div>
</template>
<script>    
    import requestServices from './request_services'
    import ticketSupport from './support'
    import { supportMixins } from '@/plugins/support'
    export default {
        name: 'SERVICES',
        mixins: [supportMixins],
        data () {
          return {
            loadServiceRequest : "requestServiceElement",
            ticket_status : "",
            pageLoader : false,
            mobtoggleButton : false,
            notification_msg:'',
            notification_type:'',
            loaderFuncRun : '1',
			setView : '',
            menu:{
                requestServiceElement:'Support Request',
                openRequest:'Open Requests',
                closeRequest:'Closed Requests'
            }
          }
        }, 
        components: {
            appRequestServices: requestServices,
            appTicketSupport: ticketSupport
        },
        computed:{
            tabActiveFunction(){
                localStorage.setItem("tabName", this.$route.params.tabName);
                this.loadServiceRequest = localStorage.getItem("tabName", this.$route.params.tabName);
                this.ticket_status = (this.loadServiceRequest == 'openRequest' ? '0' : '3')
            }
        },
        methods:{
            enableRequestElement(elementName){
				//this.setView = ''
                this.loadServiceRequest = elementName
                this.mobtoggleButton = false
                this.$router.replace({ name: "support", params: {tabName:elementName}})
            },
            
        },
        created(){
			if(this.$route.params.page && this.$route.params.page  == 'view_dash'){
				this.setView = 'view_dash'
				this.enableRequestElement('openRequest')
			}
			this.pageName('Support')
            this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/supports/index.vue